import axios from 'axios';
let cancel = [];

const ApiService = {
  init(apiBaseUrl) {
    axios.defaults.baseURL = apiBaseUrl;
  },

  setHeader(jwtToken) {
    axios.defaults.headers.common['Authorization'] = jwtToken;
  },

  removeHeader() {
    axios.defaults.headers.common = {};
  },

  get(resource, data) {
    let CancelToken = axios.CancelToken;
    let cancelToken;

    let gt = function() {
      if (cancel[resource] != undefined) {
        cancel[resource]();
      }

      if (data) {
        data.cancelToken = new CancelToken(function executor(c) {
          cancel[resource] = c;
        });
      }
    };

    gt();
    
    // Para desenvolvimento local, usar cookies/sessão
    const isLocalhost = axios.defaults.baseURL && axios.defaults.baseURL.includes('localhost');
    if (isLocalhost) {
      return axios.get(resource, { ...data, withCredentials: true });
    }
    
    return axios.get(resource, data, cancelToken);
  },

  post(resource, data) {
    const isLocalhost = axios.defaults.baseURL && axios.defaults.baseURL.includes('localhost');
    if (isLocalhost) {
      return axios.post(resource, data, { withCredentials: true });
    }
    return axios.post(resource, data);
  },

  put(resource, data) {
    const isLocalhost = axios.defaults.baseURL && axios.defaults.baseURL.includes('localhost');
    if (isLocalhost) {
      return axios.put(resource, data, { withCredentials: true });
    }
    return axios.put(resource, data);
  },

  delete(resource) {
    const isLocalhost = axios.defaults.baseURL && axios.defaults.baseURL.includes('localhost');
    if (isLocalhost) {
      return axios.delete(resource, { withCredentials: true });
    }
    return axios.delete(resource);
  }
};

export default ApiService;
